<div
  [ngClass]="{
    'bg-red-50 border-red-200': isMissing,
    'bg-blue-50 border-blue-200': !isMissing,
  }"
  class="rounded-lg p-6 shadow-sm border"
>
  <div class="flex mb-4">
    <div class="flex flex-col">
      <div
        class="font-bold rounded-full w-8 h-8 flex items-center justify-center mr-3"
        [ngClass]="{
          'bg-red-100 border-red-200': isMissing,
          'bg-blue-100 text-blue-700': !isMissing,
        }"
      >
        {{ question.index_number }}
      </div>
    </div>
    <h2 class="text-lg font-semibold">
      <span [innerHTML]="questionHtml | safeHtml"></span>
    </h2>
  </div>
  <div class="mt-4 px-10">
    <textarea
      [name]="'question_' + question.uuid"
      (input)="handleInput($event)"
      rows="4"
      maxlength="200"
      class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      placeholder="Enter your answer here..."
    ></textarea>
    <p class="text-sm text-gray-500 mt-2 text-right">{{ charCount }}/200 characters</p>
  </div>
</div>
